import Typography from "components/typography";
import React, { useState } from "react";
import styled from "styled-components";

const VideoDetails = () => {
  const [videoHover, setVideoHover] = useState(false);
  return (
    <Container>
      <VideoContainer
        onMouseEnter={() => {
          setVideoHover(true);
        }}
        onMouseLeave={() => {
          setTimeout(() => {
            setVideoHover(false);
          }, 2000);
        }}
      >
        <VideoElemetDetails isopen={videoHover ? "true" : "false"}>
          <Typography size="lg" weight="bold" mb="0.4">
            Blueberry Faygo
          </Typography>
          <Typography size="s" weight="medium">
            Lil Mosey
          </Typography>
        </VideoElemetDetails>
        <VideoElement controls>
          {/* <source src="movie.mp4" type="video/mp4"/> */}
          Your browser does not support the video tag.
        </VideoElement>
      </VideoContainer>
      <TextArea>
        <div>
          <Typography size="2xl" weight="bold" mb="0.8">
            Blueberry Faygo
          </Typography>
          <Typography>Lil Mosey</Typography>
        </div>
        <ReleaseDetailsGrid>
          <Typography size="xs" weight="semibold">
            UPLOADED
          </Typography>
          <Typography size="xs" weight="semibold">
            RELEASE DATE
          </Typography>
          <Typography size="xs" weight="semibold">
            ORIGINAL RELEASE DATE
          </Typography>
          <Typography size="s">21st September 2024</Typography>
          <Typography size="s">10th October 2024</Typography>
          <Typography size="s">N/A</Typography>
        </ReleaseDetailsGrid>
      </TextArea>
    </Container>
  );
};

export default VideoDetails;

const Container = styled.div`
  margin-top: 3.2rem;
  width: 100%;
`;

const VideoContainer = styled.div`
  width: 100%;
  height: 56rem;
  position: relative;
  overflow: hidden;
  @media only screen and (max-width: 769px) {
    height: 24rem;
  }
`;
const VideoElement = styled.video`
  width: 100%;
  height: 100%;
  position: relative;
`;

const VideoElemetDetails = styled.div<{ isopen: string }>`
  color: white;
  padding: 1.6rem;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  transform: ${(props) =>
    props.isopen === "true" ? "translateY(0)" : "translateY(-100%)"};
  opacity: ${(props) => (props.isopen === "true" ? "1" : "0")};
  transition: ease-in-out 0.2s all;
`;

const TextArea = styled.div`
  margin-top: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media only screen and (max-width: 769px) {
    flex-direction: column;
    row-gap: 1.6rem;
    align-items: start;
  }
`;

const ReleaseDetailsGrid = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  grid-column-gap: 1.6rem;
  grid-row-gap: 0.5rem;
  color: white;
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;
